import React, {useEffect} from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {setAdminToolSettingsPopupVisible} from "./adminActions";
import WithOverlay from "../../popups/withOverlayHoc";
import {postEditFeatures} from "../../../api/admin-api";
import LoadingSpinner from "../../ui/loadingSpinner";
import CheckBox from "../../common/checkBox";
import {getEditFeaturesRequestData} from "./adminFunctions";


const SuperAdminToolSettingsPopup = (props) => {

  const {adminToolSettingsPopupVisible, setAdminToolSettingsPopupVisible, adminToolSettingsPopupFeature,
    fabricatorSubscriptions} = props;

  const [toolSettings, setToolSettings] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    // copy: dbFeature.toolSettings arrays are interned (shared by many features, see dbFeatureSlim.ts) - never mutate them
    setToolSettings(adminToolSettingsPopupFeature
      ? (adminToolSettingsPopupFeature.dbFeature.updatedToolSettings || adminToolSettingsPopupFeature.dbFeature.toolSettings || []).slice()
      : [])
  }, [adminToolSettingsPopupFeature]);

  if (!adminToolSettingsPopupVisible) {
    return null
  }

  const closeModal = () => {
    setAdminToolSettingsPopupVisible(false);
  }

  const onChecked = (subscription, property) => {
    // create toolSetting object if it is missing (without mutating the current array)
    const currentToolSettings = toolSettings.some(subscr => subscr.tool === subscription)
      ? toolSettings
      : [...toolSettings, {tool: subscription}];
    setToolSettings([...currentToolSettings.map(subscr => {
      if (subscr.tool === subscription) {
        return Object.assign({}, subscr, {[property]: !subscr[property]})
      }
      return subscr
    })]);
  }

  const handleApply = async (apply, hideOverlay) => {
    if (apply) {
      const {postDiffData, featuresToUpdate} = getEditFeaturesRequestData(adminToolSettingsPopupFeature, toolSettings);
      if (postDiffData) {
        setLoading(true);
        const saved = await postEditFeatures(postDiffData);
        console.log("featuresToUpdate saved", saved, featuresToUpdate, postDiffData);
        if (saved) {
          featuresToUpdate.forEach(feature => {
            feature.dbFeature.updatedToolSettings = toolSettings;
          })
        }
        setLoading(false);
      }
    }
    hideOverlay(closeModal);
  }

  return (
    <WithOverlay className="overlay--confirm">
      {(hideOverlay) => (
        <div className={"confirm-popup "
          + (fabricatorSubscriptions.length > 2 ? "confirm-popup--message2" : "confirm-popup--message")}>
          <h3 className="ui-add-note margin-t-0 margin-b-0">Editing {adminToolSettingsPopupFeature.getFeatureName()}</h3>
          <button className="apply-popup-header__close ui-close" onClick={() => hideOverlay(closeModal)}/>
          <div className="fs-toggle-popup__table width-100">
            <div className="fs-toggle-popup__table-row">
              <div className="fs-toggle-popup__table-col fs-toggle-popup__table-col--name"/>
              <div className="fs-toggle-popup__table-col fs-toggle-popup__table-col--checkbox">
                <span className="secondary">
                  <FormattedMessage id="features.setup.togglePopup.visualizer"/>
                </span>
              </div>
              <div className="fs-toggle-popup__table-col fs-toggle-popup__table-col--checkbox">
                <span className="secondary">
                  <FormattedMessage id="features.setup.togglePopup.quoting"/>
                </span>
              </div>
            </div>
            {fabricatorSubscriptions.map(subscription => {
              return (
                <div className="fs-toggle-popup__table-row bordered" key={subscription.service}>
                  <div className="fs-toggle-popup__table-col fs-toggle-popup__table-col--name">
                    {subscription.service}
                  </div>
                  {["visualizer", "quoting"].map((view) => {
                    const property = view === "visualizer" ? "enableVisualizer" : "enableQuotingTool";
                    const toolSettingsObject = toolSettings.find(setting => setting.tool === subscription.service);
                    return (
                      <div className="fs-toggle-popup__table-col fs-toggle-popup__table-col--checkbox" key={view}>
                        {property ? (
                          <CheckBox checked={toolSettingsObject && toolSettingsObject[property]}
                                    innerStyle="none"
                                    type={"medium"}
                                    onChecked={() => onChecked(subscription.service, property)}
                                    text=""/>
                        ) : null}
                      </div>
                    )
                  })}
                </div>
              )
            })}
          </div>
          <div className="confirm-popup-buttons margin-b-8">
            <button className="ui-button2 ui-button2--blue" onClick={() => handleApply(false, hideOverlay)}>
              <FormattedMessage id="confirmPopup.buttonCancel"/>
            </button>
            <button className="ui-button2 ui-button2--green" onClick={() => handleApply(true, hideOverlay)}>
              {loading ? <LoadingSpinner size="30"/> : <FormattedMessage id="buttons.save"/>}
            </button>
          </div>
        </div>
      )}
    </WithOverlay>
  )
};

const mapStateToProps = (store) => {
  const {adminToolSettingsPopupVisible, adminToolSettingsPopupFeature} = store.adminState;
  const {fabricatorSubscriptions} = store.fabricatorState;
  return {
    adminToolSettingsPopupVisible,
    adminToolSettingsPopupFeature,
    fabricatorSubscriptions,
  };
};

const mapDispatchToProps = {
  setAdminToolSettingsPopupVisible,
};

export default connect(mapStateToProps, mapDispatchToProps)(SuperAdminToolSettingsPopup)
